import { Component } from "@angular/core";
import { InactivityService } from "./serviceInactivity/inactivity.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "app";

  constructor(private inactivityService: InactivityService) {}
}
